import { Link } from 'react-router-dom';
import { LC_URL, MF_URL, CB_URL, DF_URL } from '../constants';

function Footer() {
  return (
    <footer className="wf-footer">
      <div className="wf-container wf-footer-content">
        <div>
          <div className="wf-logo">Winvasion</div>
          <p>In the trenches every day.</p>
        </div>
        <div className="wf-footer-links">
          <a href={LC_URL} target="_blank" rel="noreferrer">LINE CRM</a>
          <a href={MF_URL} target="_blank" rel="noreferrer">Magnus Famous Scheduler</a>
          <a href={CB_URL} target="_blank" rel="noreferrer">Crypto Portfolio</a>
          <a href={DF_URL} target="_blank" rel="noreferrer">Novels</a>
          <Link to="/about">About</Link>
        </div>
      </div>
      <div className="wf-footer-bottom">&copy; {new Date().getFullYear()} Winvasion Software</div>
    </footer>
  );
}

export default Footer;
